import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';
@Component({
  selector: 'app-new-merchant-product',
  templateUrl: './new-merchant-product.component.html'
})
export class NewMerchantProductComponent implements OnInit {
  selectedProduct: any;
  buttonLoading = false;
  @Input() productId: any;
  product: any;
  constructor(private drawerRef: NzDrawerRef<string>) {
  }
  ngOnInit() {

  }
  // To Stop loading and close drawer after save
  saveProduct($event) {
    this.buttonLoading = false;
    this.selectedProduct = $event;
    this.drawerRef.close($event);
  }
  // To Close drawer
  close(): void {
    this.drawerRef.close(this.selectedProduct);
  }

}
